import React from "react";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";
import AdminMenu from "../../components/admin/adminMenu";
import LocalStorageService from "../../ports/localStorage/localStorageService";

export default class Support extends React.Component {

    componentDidMount() {
        const token = LocalStorageService.getUserToken();
        if (!token) {
            window.location.assign("/admin");
        }
    }

    render() {
        return(
            <div id="layout-wrapper">
                <Navbar />
                <AdminMenu />

                <div className="main-content">

                    <div className="page-content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="page-title-box d-flex align-items-center justify-content-between">
                                        <h4 className="mb-0 font-size-18" style={{color: "#fff"}}>Soporte técnico</h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="col-md-12">
                                                <h4 className="header-title mb-4">Rellene el siguiente formulario y nos pondremos en contacto lo antes posible.</h4>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <iframe title="Formulario de Soporte" width="600" height="950" src="https://admin.aplusds.net/forms/ticket?language=spanish" frameBorder="0" allowFullScreen></iframe>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
        );
    }
}